import { useAuthStore } from '~/store/auth.store';

/**
 * File transformers are managed only from the Lily AI system tenant by super admins
 * (§1 Access). Mirrors `useConfigurationScope`'s `isSuperAdmin && activeTenant.isSystem`;
 * agentic-integrations enforces super admin server-side; this only decides what the UI shows.
 */
export function useCanManageTransformers(): boolean {
  return useAuthStore((s) => {
    const user = s.user;
    if (!user?.isSuperAdmin) return false;
    const active = user.accessibleTenants.find((t) => t.id === user.activeTenantId);
    return active?.isSystem === true;
  });
}
